<template>
    <NewsWrapper v-if="listForceNewsInfo.length > 0 ">
        <div class="title" v-for="item in listForceNewsInfo" :key="item.messageId" :id="item.messageId">
            <h4 class="news-title word-break">{{item.messageTitle}}</h4>
            <div class="news-meta">
                <span class="news-date">{{item.startDate | formatDate('DD-MM-YYYY hh:mm:ss','YYYY/MM/DD')}}</span>
                <span :class="colorMessageKind(item.messageKind)">{{item.messageKind |textMessageKind}}</span>
                <span class="notify-cat"><strong>{{item.serviceType | textServiceTypePopup}}</strong></span>
            </div>
            <p v-html="item.information" class="body-popup-news"></p>
            <br>
            <ForceNewsForm :forceNewsInfo="item" :messageId="item.messageId"/>
        </div>
    </NewsWrapper>
</template>

<script>
/**
 * @author HungNS
 */
import NewsWrapper from '@/components/common/news/NewsWrapper'
import {createNamespacedHelpers} from "vuex";
import ForceNewsForm from './components/ForceNewsForm';
import * as FORCE_NEWS_TYPE from "@/store/modules/force-news/type";

const {mapState: mapNewsState} = createNamespacedHelpers("news");
const {mapActions: mapForceNewsActions} = createNamespacedHelpers("forceNews");

export default {
    components: {NewsWrapper, ForceNewsForm},
    computed: {
        ...mapNewsState({
            listForceNewsInfo: state => state.listForceNewsInfo,
            forceNewsFlg: state => state.forceNewsFlg
        }),
    },
    methods: {
        ...mapForceNewsActions([FORCE_NEWS_TYPE.INIT_FORCE_NEWS]),
    },
    watch: {
        listForceNewsInfo: {
            handler: function (value) {
                if (value.length > 0) this[FORCE_NEWS_TYPE.INIT_FORCE_NEWS]();
            },
            deep: true,
            immediate: true
        }
    },
}
</script>

<style>

</style>
